export default __webpack_public_path__ + "static/N0017-70e9fffecdf6c5485fef7b9c234c41eb.png";